import { buildUrl } from './utils';

const state = {
  currentNodes: []
};
// /skills/:id/nodes/:nodeId
const actions = {
  getNodes({commit, rootState: { token } }, skillId) {
    const url = buildUrl([
      {
        skills: skillId
      },
      {
        nodes: ''
      }
    ]);
    return this._vm.$http.get(url).then(({ data }) => {
      commit('setCurrentNodes', data)
      return Promise.resolve(data)
    });
  },
  getNodesByDialog({rootState: { token } }, dialogId) {
    const url = buildUrl([
      {
        projects: dialogId
      },
      {
        nodes: ''
      }
    ]);
    return this._vm.$http.get(url).then(({ data }) => {
      return Promise.resolve(data)
    });
  },
  getNode({ rootState: { token } }, { skillId, idNode }) {
    const url = buildUrl([
      {
        skills: skillId
      },
      {
        nodes: idNode
      }
    ]);
    return this._vm.$http.get(url).then(({ data }) => Promise.resolve(data));
  },
  createNode({ rootState: { token } }, { skillId, data }) {
    const url = buildUrl([
      {
        skills: skillId
      },
      {
        nodes: ''
      }
    ]);
    return this._vm.$http.post(url, data).then(({ data }) => Promise.resolve(data));
  },
  updateNode({commit, rootState: { token } }, { skillId, idNode, data }) {
    const url = buildUrl([
      {
        skills: skillId
      },
      {
        nodes: idNode
      }
    ]);
    return this._vm.$http.put(url, data).then(({ data }) => {
      commit('setCurrentNodes', [data]);
      return Promise.resolve(data)
    });
  },
  removeNode({ rootState: { token } }, { skillId, idNode }) {
    const url = buildUrl([
      {
        skills: skillId
      },
      {
        nodes: idNode
      }
    ]);
    return this._vm.$http.delete(url).then(({ data }) =>  {
      return Promise.resolve(data)
    });
  },
  getActions({ rootState: { token } }, { filter }) {
    const url = buildUrl([
      {
        action: ''
      }
    ]);
    return this._vm.$http
        .get(`${url}?q=${filter.q}&sort=${filter.sort}&page=${filter.page}`)
        .then(({ data }) => Promise.resolve(data));
  },
  addActionGlobal({ rootState: { token } }, { action }) {
    const url = buildUrl([
      {
        action: ''
      }
    ]);
    return this._vm.$http.post(url, action).then(({ data }) => Promise.resolve(data));
  },
  updateActionGlobal({ rootState: { token } }, { action, actionId }) {
    const url = buildUrl([
      {
        action: actionId
      }
    ]);
    return this._vm.$http
        .put(url, {
          action: {
            name: action.name,
            args: action.args,
            actionType: action.actionType,
            isGlobal: action.isGlobal
          }
        })
        .then(({ data }) => Promise.resolve(data));
  },
  removeActionGlobal({ rootState: { token } }, { actionId }) {
    const url = buildUrl([
      {
        action: actionId
      }
    ]);
    return this._vm.$http.delete(url).then(({ data }) => Promise.resolve(data));
  },
  addAction({ rootState: { token } }, { skillId, idNode, action }) {
    const url = buildUrl([
      {
        skills: skillId
      },
      {
        nodes: idNode
      },
      {
        action: ''
      }
    ]);
    return this._vm.$http.post(url, action).then(({ data }) => Promise.resolve(data));
  },
  updateAction({ rootState: { token } }, { skillId, idNode, action, actionId }) {
    const url = buildUrl([
      {
        skills: skillId
      },
      {
        nodes: idNode
      },
      {
        action: actionId
      }
    ]);
    return this._vm.$http
        .put(url, {
          action: {
            name: action.name,
            args: action.args,
            argsReaded: action.argsReaded,
            actionType: action.actionType,
            isGlobal: action.isGlobal
          }
        })
        .then(({ data }) => Promise.resolve(data));
  },
  removeAction({ rootState: { token } }, { skillId, idNode, actionId }) {
    const url = buildUrl([
      {
        skills: skillId
      },
      {
        nodes: idNode
      },
      {
        action: actionId
      }
    ]);
    return this._vm.$http.delete(url).then(({ data }) => Promise.resolve(data));
  },
  cloneNode({commit, rootState: { token } }, { skillId, idNode, data }) {
    const url = buildUrl([
      {
        skills: skillId
      },
      {
        nodes: idNode
      },
      {
        clone: ''
      }
    ]);
    return this._vm.$http.post(url, data).then(({ data }) => {
      return Promise.resolve(data)
    });
  }
};

const mutations = {
  setCurrentNodes(state, value) {
    state.currentNodes = value;
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations
};
